var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theoryQuestionBank"},[(_vm.id == 2)?_c('theoryDetail'):_vm._e(),_c('keep-alive',[(_vm.id != 2)?_c('theoryList'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }